<script>
  import { onDestroy, onMount } from 'svelte';
  import PreloadBox from '@components/PreloadBox.svelte';

  export let loadingDelay = 3000;
  let loadingSkeletonCardsStep = 0;

  let placeholderItems = [];

  let placeholderItemCounts = {
    step1: {
      items: 1,
    },
    step2: {
      items: 3,
    },
    step3: {
      items: 8,
    },
  };

  let setPlaceholderItems = (step) => {
    let placeholderAmount = new Array(placeholderItemCounts[step].items);
    placeholderItems = [...placeholderAmount];
  };

  $: if (loadingSkeletonCardsStep == 1) {
    setPlaceholderItems('step1');
  } else if (loadingSkeletonCardsStep == 2) {
    setPlaceholderItems('step2');
  } else if (loadingSkeletonCardsStep == 3) {
    setPlaceholderItems('step3');
  }

  let updateStep = () => {
    loadingSkeletonCardsStep++;
    if (loadingSkeletonCardsStep == 3) {
      clearSkeletonTimer();
    }
  };

  let startIncrement;

  let incrementSkeletonCount = () => {
    startIncrement = setInterval(updateStep, loadingDelay);
  };

  let clearSkeletonTimer = () => {
    clearInterval(startIncrement);
  };

  onMount(incrementSkeletonCount);
  onDestroy(clearSkeletonTimer);
</script>

<style style="text/scss" lang="scss">
  .loading-photo-gallery {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 1rem;
    margin-top: 20px;
    > .loading-item-container {
      height: 143px;
      width: 100%;
    }
  }
</style>

<div class="photos-container">
  <slot name="input-photo-label" />
  <slot name="input-photo-upload" />
  <div class="loading-photo-gallery">
    {#each placeholderItems as _item}
      <div class="loading-item-container">
        <PreloadBox />
      </div>
    {/each}
  </div>
</div>
